import { InMemoryCache } from '@apollo/client';
import { CachePersistor, LocalStorageWrapper } from 'apollo3-cache-persist';

import esgKpiPolicy from './typePolicies/esgKpiPolicy';
import maEvaluationSurveyPolicy from './typePolicies/maEvaluationSurveyPolicy';
import userPolicies from './typePolicies/user';

export const cache = new InMemoryCache({
  typePolicies: {
    Task: {
      fields: {
        subtasks: {
          merge: false,
        },
      },
    },
    ...userPolicies,
    ...maEvaluationSurveyPolicy,
    ...esgKpiPolicy,
  },
});

export const cachePersistor = new CachePersistor({
  cache,
  debounce: 1000,
  storage: new LocalStorageWrapper(window.localStorage),
});
